import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '#',
      redirect: '/home',
      component: () => import(/* webpackChunkName: "page" */ '@/pages/layout/index.vue'),
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/home/index.vue')
        },
        {
          path: '/product',
          name: 'product',
          redirect: '/product/wrzskf',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/product/index.vue'),
          children: [
            {
              path: '/product/wrzskf',
              name: 'wrzskf',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/wrzskf.vue')
            },
            {
              path: '/product/ymt',
              name: 'ymt',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/ymt.vue')
            },
            {
              path: '/product/ythpt',
              name: 'ythpt',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/ythpt.vue')
            },
            {
              path: '/product/znwrfl',
              name: 'znwrfl',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/znwrfl.vue')
            },
            {
              path: '/product/zdhgczb',
              name: 'zdhgczb',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/zdhgczb.vue')
            },
            {
              path: '/product/DCS',
              name: 'DCS',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/DCS.vue')
            }
          ]
        },
        {
          path: '/industry',
          name: 'industry',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/industry/index.vue')
        },
        {
          path: '/yun',
          name: 'yun',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/yun/index.vue')
        },
        {
          path: '/about',
          name: 'about',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/about/index.vue')
        }
      ]
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js